import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
export function phoneNumberWrapping(phoneNumber: string): string {
  phoneNumber = phoneNumber.replace(/[\s-]/g, '');
  if (/^\d{8}$/.test(phoneNumber)) {
    return '+852' + phoneNumber;
  }
  if (/^\d$/.test(phoneNumber)) {
    return '+' + phoneNumber;
  }
  return phoneNumber;
}

export class CommonValidators {
  static phone(control: AbstractControl): ValidationErrors | null {
    const reg = /^(\+[0-9]+|[0-9]{8})$/;

    const isValid = RegExp(reg).test(control.value);
    return isValid ? null : { phoneformat: 'regerror.phoneformat' };
  }

  static email(control: AbstractControl): ValidationErrors | null {
    const isValid = !Validators.email(control);
    return isValid ? null : { emailformat: 'regerror.emailformat' };
  }

  static include<T>(test: T[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!test.includes(control.value)) {
        return { notFound: 'notfound' };
      }

      return null;
    };
  }
}
